// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const NEW_FEATURE_TAG = "Novinka";
